import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HoldedFieldStatusEnum, HoldedFieldStatusLabels } from 'src/app/enums/holded-field-status.enum';
import { HoldedConfiguredKpiData } from 'src/app/models/holded-configured-kpi-data.model';
import { ProductionKeyPerformanceIndicatorEvaluationWithData } from 'src/app/models/production-key-performance-indicator-evaluation.model';

@Component({
  selector: 'app-holded-configured-details',
  imports: [MatTooltipModule],
  templateUrl: './holded-configured-details.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './holded-configured-details.component.css',
})
export class HoldedConfiguredDetailsComponent {
  readonly HoldedFieldStatusEnum = HoldedFieldStatusEnum;
  readonly HoldedFieldStatusLabels = HoldedFieldStatusLabels;

  kpiData = input.required<ProductionKeyPerformanceIndicatorEvaluationWithData>();

  holdedData = computed((): HoldedConfiguredKpiData | null => {
    const rawData = this.kpiData().data?.[0]?.data;
    return HoldedConfiguredDetailsComponent.isHoldedConfiguredKpiData(rawData) ? rawData : null;
  });

  companyFieldStatus = computed((): HoldedFieldStatusEnum => {
    const data = this.holdedData();
    if (!data) {
      return HoldedFieldStatusEnum.Pending;
    }

    if (data.company_holded_id_exists_in_holded) {
      return HoldedFieldStatusEnum.Configured;
    }

    return data.has_company_holded_id ? HoldedFieldStatusEnum.Invalid : HoldedFieldStatusEnum.Pending;
  });

  companyProductFieldStatus = computed((): HoldedFieldStatusEnum => {
    const data = this.holdedData();
    if (!data) {
      return HoldedFieldStatusEnum.Pending;
    }

    if (data.company_product_holded_accounting_account_id_exists_in_holded) {
      return HoldedFieldStatusEnum.Configured;
    }

    return data.has_company_product_holded_accounting_account_id ? HoldedFieldStatusEnum.Invalid : HoldedFieldStatusEnum.Pending;
  });

  public static isHoldedConfiguredKpiData(value: unknown): value is HoldedConfiguredKpiData {
    if (typeof value !== 'object' || value === null || Array.isArray(value)) {
      return false;
    }

    const candidate = value as Record<string, unknown>;

    return (
      typeof candidate.has_company_holded_id === 'boolean' &&
      typeof candidate.has_company_product_holded_accounting_account_id === 'boolean' &&
      typeof candidate.company_holded_id_exists_in_holded === 'boolean' &&
      typeof candidate.company_product_holded_accounting_account_id_exists_in_holded === 'boolean' &&
      typeof candidate.is_configured === 'boolean' &&
      typeof candidate.configured_fields_count === 'number' &&
      typeof candidate.total_fields_count === 'number'
    );
  }
}
